export default {
  main:                 "#37a0be",
  mainHover:            "#31859e",
  mainAccessible:       "#15809d",
  mainAccessibleHover:  "#37a0be",

  secondary:            "#8e4585",

  accent:               "#05c789",
  accentHover:          "#024b33",
  accentAccessible:     "#00aa73", //for use with white text

  highlight:            "#de333e",
  highlightHover:       "#82141c",

  disabled:             "#696969",
  alertText:            "#ba3a4f",

  coreColor1:           "#000000",
  coreColor2:           "#ffffff",
  coreColor3:           "#cccccc"
}